import { makeObservable, observable } from 'mobx';

export class Account {
  static modelName = 'Account';

  constructor(fields: Record<string, never>) {
    this.id = fields.id;
    this.provider = fields.provider;

    makeObservable(this, {
      id: observable,
      provider: observable,
    });
  }

  id!: string;

  provider!: string;
}
